// import { Link } from "react-router-dom";
// import { useEffect, useState } from "react";
// import Breadcrumb from "../Components/Breadcrumb";
// import UnderMaintanence from "./UnderMaintanence";
// import {
//   STUDENTCOUNCIL,
//   EQUALCELL,
//   ANTIRAGGING_SQUAD,
//   ANTI_RAGGING,
//   CommitteeData,
//   Initiatives,
//   InternalCommittee,
//   StudentGrievanceData,
//   GOVERNINGCOUNCIL,
//   Academic_Council,
// } from "../Data/GovernanceData";
// import organizationChart from "../assets/Library/OrganizationChart.jpg";

// const sidemenus = [
//   {
//     title: "Organization Chart",
//     url: "/governance/OrganizationChart",
//   },
//   {
//     title: "College Development Committee",
//     url: "/governance/CollegeDevelopmentCommittee",
//   },
//   {
//     title: "Internal Quality Assurance Committee",
//     url: "/governance/InternalQualityAssuranceCommittee",
//   },
//   {
//     title: "Anti Ragging Committee",
//     url: "/governance/AntiRaggingCommittee",
//   },
//   {
//     title: "Internal Complaint Committee",
//     url: "/governance/InternalComplaintCommittee",
//   },
//   {
//     title: "Student Grievance Redressal",
//     url: "/governance/StudentGrievanceRedressalCommittee",
//   },
//   {
//     title: "SC-ST-Committee",
//     url: "/governance/SC-ST-Committee",
//   },
//   {
//     title: "Anti Ragging Squad",
//     url: "/governance/AntiRaggingSquad",
//   },
//   {
//     title: "Equal Opportunity Cell",
//     url: "/governance/EqaulOpprtunityCell",
//   },
//   {
//     title: "Student Council",
//     url: "/governance/StudentCouncil",
//   },
//   {
//     title: "Governing Council",
//     url: "/governance/GoverningCouncil",
//   },
//   {
//     title: "Academic Council",
//     url: "/governance/Academic_Council",
//   },
//    {
//     title: "BOS Members MBA",
//     url: "/governance/BOSMembersMBA",
//   },
//    {
//     title: "BOS Members MCA BCA",
//     url: "/governance/BOSMembersMCABCA",
//   },
// ];

// export default function Governance(props) {
//   const [menuName, setName] = useState(props.pageName);
//   const [menuId, setId] = useState(props.pageId);

//   useEffect(() => {
//     let id = menuId.toString();
//     document.getElementById(id).setAttribute("class", "active-menu");

//     // Add d-none class for all divs
//     sidemenus.forEach((element) => {
//       let id = element.title.split(" ").join("").toString();
//       document.getElementById(id).classList.add("d-none");
//     });

//     // remove class d-none of particular div on click by getting Id
//     let divId = menuName.split(" ").join("").toString();
//     document.getElementById(divId).classList.remove("d-none");

//     // scroll top
//     window.scrollTo(0, 0);
//   }, [menuName, menuId]);

//   const handleClick = (event) => {
//     setName(event.currentTarget.textContent);
//     setId(event.currentTarget.id);

//     // Remove all class active-menu of '.sideMenu a' on click
//     const allWithClass = Array.from(document.querySelectorAll(".sideMenu a"));

//     allWithClass.forEach((element) => {
//       element.classList.remove("active-menu");
//     });
//   };

//   return (
//     <>
//       <Breadcrumb pageTitle={menuName} />
//       <div className="container mt-3">
//         <div className="row default-padding-bottom">
//           {/* Sidebar */}
//           <aside className="sideMenu col-lg-3">
//             <div className="scroll-div">
//               {sidemenus.map((menu, index) => {
//                 return (
//                   <Link
//                     key={index}
//                     id={index}
//                     onClick={handleClick}
//                     to={menu.url}
//                   >
//                     {" "}
//                     {menu.title}{" "}
//                   </Link>
//                 );
//               })}
//             </div>
//           </aside>
//           {/* content */}
//           <div className="col-lg-9">
//             <div className="px-lg-3 px-1">
//               {sidemenus.map((menu, index) => {
//                 return (
//                   <div
//                     id={menu.title.split(" ").join("").toString()}
//                     key={index}
//                   >
//                     {props.pageContent}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export function Organization() {
//   return (
//     <div>
//       {/* <h5 className="title-text my-2 mb-4">Organization Chart</h5>  */}
//       <div>
//         <img
//           src={organizationChart}
//           height={"auto"}
//           width={700}
//           className="px-5"
//         />
//       </div>
//     </div>
//   );
// }

// export function CollegeDevelopment() {
//   return (
//     <div>
//       <h5 className="title-text my-4 mt-2">
//         College Development Committee (CDC)
//       </h5>
//       <div>
//         <ul>
//           <li>Prof. Dr. Gajanan R. Ekbote(Chairman)</li>
//           <li>Prof. Dr. Milind D. Alandikar (Visitor)</li>
//           <li>Prof. S. S. Deshmukh (Education)</li>
//           <li>Prof. Dr. Ms. N. G. Ekbote (Research)</li>
//           <li>Prof. Dr. P. D. Choudhari (Special Invitee)</li>
//           <li>Prof. Suresh Todkar (Member)</li>
//           <li>Shree Deepak Marathe (Member)</li>
//           <li>Shri Mayuresh Pujari (Member)</li>
//           <li>Dr. Maithili Arjunwadkar (Director)</li>
//           <li>Dr. Manoj Sathe (Spl. Invitee)</li>
//           <li>Mr. Prashant Markale (Spl. Invitee)</li>
//           <li>Prof. Dr. Mrs. Vijayalaxmi Shrinivas (Member)</li>
//         </ul>
//       </div>
//     </div>
//   );
// }

// export function InternalQualityAssurance() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">
//           Internal Quality Assurance Committee
//         </h5>

//         <Initiatives />
//       </div>
//     </div>
//   );
// }

// export function AntiRagging() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">ANTI RAGGING COMMITTEE</h5>

//         <ANTI_RAGGING />
//         <p>Contact us 9011070916</p>
//       </div>
//     </div>
//   );
// }

// export function InternalComplaint() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text  mb-2">Internal Complaint Committee</h5>
//         <InternalCommittee />
//         <p>Contact us 9011070916</p>
//       </div>
//     </div>
//   );
// }

// export function StudentGrievance() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">
//           Student Grievance Redressal Committee
//         </h5>

//         <StudentGrievanceData />
//         <p>Contact us 9011070916</p>
//       </div>
//     </div>
//   );
// }

// // SC/ST Committee

// export function SCST_Committee() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">SC/ST Committee</h5>
//         <CommitteeData />
//       </div>
//     </div>
//   );
// }

// export function AntiRaggingSquad() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Anti Ragging Squad</h5>
//         <ANTIRAGGING_SQUAD />
//       </div>
//     </div>
//   );
// }

// export function EqualCell() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Equal Opportunity Cell</h5>
//         <EQUALCELL />
//       </div>
//     </div>
//   );
// }

// export function StudentCouncil() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Student Council</h5>
//         <STUDENTCOUNCIL />
//       </div>
//     </div>
//   );
// }

// export function GoverningCouncil() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Governing Council</h5>
//         <GOVERNINGCOUNCIL />
//       </div>
//     </div>
//   );
// }

// export function AcademicCouncil() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Governing Council</h5>
//         <Academic_Council />
//       </div>
//     </div>
//   );
// }

// export function BOSMembersMBA() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Governing Council</h5>
//         <BOSMembersMBA />
//       </div>
//     </div>
//   );
// }

// export function BOSMembersMCABCA() {
//   return (
//     <div>
//       <div>
//         <h5 className="title-text mb-2">Governing Council</h5>
//         <BOSMembersMCABCA />
//       </div>
//     </div>
//   );
// }

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Breadcrumb from "../Components/Breadcrumb";
import {
  STUDENTCOUNCIL,
  EQUALCELL,
  ANTIRAGGING_SQUAD,
  ANTI_RAGGING,
  CommitteeData,
  Initiatives,
  InternalCommittee,
  StudentGrievanceData,
  GOVERNINGCOUNCIL,
  Academic_Council,
  BOSMembersMBA as BOSMBAData,
  BOSMembersMCABCA as BOSMCABCAData,
  DivyangCellTable,
} from "../Data/GovernanceData";
import organizationChart from "../assets/Library/OrganizationChart.jpg";

const sidemenus = [
  { title: "Organogram", url: "/governance/OrganizationChart" },
  {
    title: "College Development Committee",
    url: "/governance/CollegeDevelopmentCommittee",
  },
  {
    title: "Statutory Committee",
    url: null,
    children: [
      {
        title: "Internal Complaint Committee",
        url: "/governance/InternalComplaintCommittee",
      },
      {
        title: "Student Grievance Redressal Committee",
        url: "/governance/StudentGrievanceRedressalCommittee",
      },
      {
        title: "Anti Ragging Committee",
        url: "/governance/AntiRaggingCommittee",
      },
      { title: "Anti Ragging Squad", url: "/governance/AntiRaggingSquad" },
      { title: "SC-ST-Committee", url: "/governance/SC-ST-Committee" },
    ],
  },
  { title: "Governing Body", url: "/governance/GoverningCouncil" },
  { title: "Academic Council", url: "/governance/Academic_Council" },
  {
    title: "Board of Studies",
    url: null,
    children: [
      { title: "MBA", url: "/governance/BOSMembersMBA" },
      { title: "MCA/BCA", url: "/governance/BOSMembersMCABCA" },
    ],
  },
  { title: "Equal Opportunity Cell", url: "/governance/EqaulOpprtunityCell" },
  { title: "Divyang Cell", url: "/governance/DivyangCell" },
  { title: "Student Council", url: "/governance/StudentCouncil" },
  // {
  //   title: "Internal Quality Assurance Committee",
  //   url: "/governance/InternalQualityAssuranceCommittee",
  // },
];

const allMenus = sidemenus.flatMap((menu) =>
  menu.children ? menu.children : [menu],
);

export default function Governance(props) {
  const [openParent, setOpenParent] = useState(() => {
    // Auto-open parent if current page is a child
    const found = sidemenus.find(
      (menu) =>
        menu.children &&
        menu.children.some((child) => child.title === props.pageName),
    );
    return found ? found.title : null;
  });

  useEffect(() => {
    // Auto-expand parent on prop change (navbar navigation)
    sidemenus.forEach((menu) => {
      if (menu.children) {
        const isChildActive = menu.children.some(
          (child) => child.title === props.pageName,
        );
        if (isChildActive) setOpenParent(menu.title);
      }
    });
    window.scrollTo(0, 0);
  }, [props.pageName]);

  const toggleParent = (title) => {
    setOpenParent((prev) => (prev === title ? null : title));
  };

  return (
    <>
      <Breadcrumb pageTitle={props.pageName} />
      <div className="container mt-3">
        <div className="row default-padding-bottom">
          {/* Sidebar */}
          <aside className="sideMenu col-lg-3">
            <div
              className="scroll-div"
              style={{ display: "flex", flexDirection: "column" }}
            >
              {sidemenus.map((menu, index) => {
                if (menu.children) {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            toggleParent(menu.title);
                          }}
                          style={{
                            flex: 1,
                            cursor: "pointer",
                            justifyContent: "space-between",
                          }}
                        >
                          {menu.title}
                          <span
                            style={{
                              cursor: "pointer",
                              padding: "0 8px",
                              fontSize: "20px",
                            }}
                          >
                            {openParent === menu.title ? "▲" : "▼"}
                          </span>
                        </a>
                      </div>
                      {openParent === menu.title && (
                        <div
                          style={{
                            paddingLeft: "12px",
                            borderLeft: "3px solid #ccc",
                            marginLeft: "8px",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          {menu.children.map((child, childIndex) => (
                            <Link
                              key={childIndex}
                              to={child.url}
                              className={
                                props.pageName === child.title
                                  ? "active-menu"
                                  : ""
                              }
                              style={{
                                display: "block",
                                fontSize: "0.9rem",
                                wordBreak: "break-word", // 👈 add this
                                whiteSpace: "normal",
                              }}
                            >
                              ↳ {child.title}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                }
                return (
                  <Link
                    key={index}
                    to={menu.url}
                    className={
                      props.pageName === menu.title ? "active-menu" : ""
                    }
                  >
                    {menu.title}
                  </Link>
                );
              })}
            </div>
          </aside>

          {/* Content */}
          <div className="col-lg-9">
            <div className="px-lg-3 px-1">{props.pageContent}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export function Organization() {
  return (
    <div>
      <div>
        <img
          src={organizationChart}
          height={"auto"}
          width={700}
          className="px-5"
        />
      </div>
    </div>
  );
}

export function CollegeDevelopment() {
  return (
    <div>
      <h5 className="title-text my-4 mt-2">
        College Development Committee (CDC)
      </h5>
      <div>
        <ul>
          <li>Prof. Dr. Gajanan R. Ekbote(Chairman)</li>
          <li>Prof. Dr. Milind D. Alandikar (Visitor)</li>
          <li>Prof. S. S. Deshmukh (Education)</li>
          <li>Prof. Dr. Ms. N. G. Ekbote (Research)</li>
          <li>Prof. Dr. P. D. Choudhari (Special Invitee)</li>
          <li>Prof. Suresh Todkar (Member)</li>
          <li>Shree Deepak Marathe (Member)</li>
          <li>Shri Mayuresh Pujari (Member)</li>
          <li>Dr.Aruna Deoskar(Director)</li>
          <li>Dr.Sudarshan Pawar( spl.Invitee)</li>
          <li>Mr. Prashant Markale (Spl. Invitee)</li>
          <li>Prof. Dr. Mrs. Vijayalaxmi Shrinivas (Member)</li>
        </ul>
      </div>
    </div>
  );
}

export function AntiRagging() {
  return (
    <div>
      <h5 className="title-text mb-2">ANTI RAGGING COMMITTEE</h5>
      <ANTI_RAGGING />
      {/* <p>Contact us 9011070916</p> */}
    </div>
  );
}

export function InternalComplaint() {
  return (
    <div>
      <h5 className="title-text mb-2">Internal Complaint Committee</h5>
      <InternalCommittee />
      {/* <p>Contact us 9011070916</p> */}
    </div>
  );
}

export function StudentGrievance() {
  return (
    <div>
      <h5 className="title-text mb-2">Student Grievance Redressal Committee</h5>
      <StudentGrievanceData />
      {/* <p>Contact us 9011070916</p> */}
    </div>
  );
}

export function SCST_Committee() {
  return (
    <div>
      <h5 className="title-text mb-2">SC/ST Committee</h5>
      <CommitteeData />
    </div>
  );
}

export function AntiRaggingSquad() {
  return (
    <div>
      <h5 className="title-text mb-2">Anti Ragging Squad</h5>
      <ANTIRAGGING_SQUAD />
    </div>
  );
}

export function EqualCell() {
  return (
    <div>
      <h5 className="title-text mb-2">Equal Opportunity Cell</h5>
      <EQUALCELL />
    </div>
  );
}

export function DivyangCell() {
  return (
    <div>
      <h5 className="title-text mb-2">Divyang Cell A.Y. 2025-26</h5>
      <DivyangCellTable />
    </div>
  );
}

export function StudentCouncil() {
  return (
    <div>
      <h5 className="title-text mb-2">Student Council</h5>
      <STUDENTCOUNCIL />
    </div>
  );
}

export function GoverningCouncil() {
  return (
    <div>
      <h5 className="title-text mb-2">Governing Body</h5>
      <GOVERNINGCOUNCIL />
    </div>
  );
}

export function AcademicCouncil() {
  return (
    <div>
      <h5 className="title-text mb-2">Academic Council</h5>
      <Academic_Council />
    </div>
  );
}

export function BOSMembersMBAPage() {
  return (
    <div>
      <h5 className="title-text mb-2">BOS Members MBA</h5>
      <BOSMBAData />
    </div>
  );
}

export function BOSMembersMCABCAPage() {
  return (
    <div>
      <h5 className="title-text mb-2">BOS Members MCA & BCA</h5>
      <BOSMCABCAData />
    </div>
  );
}
